'use strict';

export default function (document) {

    var element = $('[data-minicart]');
    var rolloverUrl = element.data('cart-rollover');

    $(document).on('open.zf.reveal', '#miniCartPopup', function () {
        var modal = $(this);
        $.ajax({
            url: rolloverUrl,
            type: 'GET',
            dataType: 'json',
            error: function () {
                //
            },
            complete: function () {
                //
            },
            success: function (data) {
                $('.minicart').html(data.html);
            }
        });
    });
}
